import React from "react";
import { Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";

const ShowMembersDialog = (props) => (
  <BaseDialog
    show={props.show}
    onHide={props.onHide}
    title={props.t("Classes.ClassModal.ShowMembersModal.Title")}
    body={
      <Table size="sm" className="students-table mt-2">
        <thead>
          <tr>
            <th>{props.t("Classes.ClassModal.ShowMembersModal.ColumnName")}</th>
            <th>
              {props.t("Classes.ClassModal.ShowMembersModal.ColumnEmail")}
            </th>
          </tr>
        </thead>
        <tbody>
          {props.class
            ? props.class.members.map((m, idx) => (
                <tr key={idx}>
                  <td>{m.name}</td>
                  <td>{m.email}</td>
                </tr>
              ))
            : ""}
        </tbody>
      </Table>
    }
  />
);

export default withTranslation()(ShowMembersDialog);
